<template>
  <modal-wrapper
      :shown="true"
      title="Choose a time to subscribe the contact"
      :classes="'action-modal-container'"
      @close-modal="$emit('close-modal')"
  >
        <div>
          <date-picker
              v-model="dateSelected"
              :min="new Date().toISOString().replace('T', ' ').slice(0, 19)"
              lang="en"
              type="datetime"
              width="480"
              input-class="date-time-picker"
              format="MM/DD/YYYY hh:mm A"
              :not-before="convertUtcDateToUserTimezoneMoment(new Date().toISOString().replace('T', ' ').slice(0, 19), 'YYYY-MM-DD HH:mm:ss', timezone).format('YYYY-MM-DD HH:mm:ss')"
              :clearable="false"
              :time-picker-options="{
                start: '00:00',
                step: '00:60',
                end: '24:00',
              }"
          >
          </date-picker
          ><br />
          <p class="text-white">
            Time zone: <b>{{ formattedTimezone }}</b>
          </p>
          <p class="date-time-caption">Click on the date above to change it.</p>
        </div>
        <button
            @click="subscribeContact(campaign, contact, dateSelected)"
            class="btn btn-danger btn-lg modal-action-button warning"
        >
          Subscribe Contact
        </button>
    </modal-wrapper>
</template>

<script>
import ModalWrapper from '../modal/ModalWrapper';
import ModalProcessingIndicator from '../modal/ModalProcessingIndicator';
import DatePicker from 'vue2-datepicker';
import {convertLocalDateToServerMoment, convertServerDateToLocalMoment, convertUtcDateToUserTimezoneMoment } from '../../utility/date/date-converter';

export default {
  name: 'subscribe-contact-modal',
  components: {ModalWrapper, ModalProcessingIndicator, DatePicker},
  data() {
    // convert server date to user timezone, and current time to user timezone
    let launchDate = convertServerDateToLocalMoment(this.campaign.launch, 'YYYY-MM-DD HH:mm:ss', this.timezone);
    let subscribeDate = convertUtcDateToUserTimezoneMoment(new Date().toISOString().replace('T', ' ').slice(0, 19), 'YYYY-MM-DD HH:mm:ss', this.timezone);
    // if the current time is greater than the launch time, add one day
    if (subscribeDate.format('HH:mm:ss') > launchDate.format('HH:mm:ss')) {
      subscribeDate.add(1, 'days');
    }
    // set the subscribe time to campaign launch time
    subscribeDate.set('hour', launchDate.get('hour'));
    subscribeDate.set('minute', launchDate.get('minute'));
    subscribeDate.set('second', launchDate.get('second'));
    return {
      processing: false,
      dateSelected: subscribeDate.format('YYYY-MM-DD HH:mm:ss'),
    };
  },
  props: {
    campaign: {
      type: Object,
      required: true,
    },
    contact: {
      type: Object,
      required: true,
    },
    lowestDate: {
      type: String,
      default: new Date().toString(),
    },
    timezone: {
      type: String,
      default: null,
    },
  },
  methods: {
    convertUtcDateToUserTimezoneMoment,
    subscribeContact(campaign, contact, subscribeAt) {
      if (subscribeAt) {
        let serverTime = convertLocalDateToServerMoment(
            this.formatDate(this.dateSelected),
            'MM/DD/YYYY HH:mm',
            this.timezone || moment.tz.guess()
        ).format('YYYY/MM/DD HH:mm');
        this.$emit('subscribe', { campaign, contact, subscribeAt: serverTime });
      } else {
        this.$emit('subscribe', { campaign, contact });
      }
      this.$emit('close-modal');
    },
    formatDate(date) {
      return moment(date).format('MM/DD/YYYY HH:mm');
    },
  },
  computed: {
    formattedTimezone() {
      return (this.timezone || moment.tz.guess()).replace('_', ' ');
    },
  },
};
</script>

<style lang="scss" scoped>
    pre {
        text-align: left;
    }

    .modal-wrapper {
      overflow-y: scroll;
    }
</style>
